import Link from "../../../ui/link";
import React, {useCallback} from "react";
import cn from "classnames";
import classes from "./AnonymousSessionsTable.module.css";
import {AnonymousResult, Challenge, ChallengeMode} from "../../../schema";
import SessionActionsList from "../../results/SessionActionsList";
import {useTranslation} from "react-i18next";
import {useQuery} from "@apollo/client";
import {PlayableAction} from "../../../redux/player/types";
import {challengeQuery} from "../../../scenes/player/results.graphql";
import {Scenario} from "../../../types";
import {useModal} from "../../ModalProvider";
import {getParametricScore} from "../../../utils";

export default function DetailedResults({challengeId, session}: {challengeId: string; session: AnonymousResult}) {
  const {t} = useTranslation();
  const {add: addModal} = useModal();

  const {data: challengeData} = useQuery<{
    challenge: Challenge;
    actions: PlayableAction[];
    additionalScenarios: Scenario[];
  }>(challengeQuery, {
    variables: {
      challengeId,
    },
  });
  const {challenge, actions, additionalScenarios} = challengeData ?? {};
  const showDetailedResults = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      if (!challenge || !actions || !challenge.showDetailedResults) {
        return;
      }

      addModal({
        className: cn(classes.modal, classes.textSelectable),
        size: "xl",
        header: <span>{t("player.results.detailed")}</span>,
        content: (
          <div className={classes.actionsListContainer}>
            {challenge?.mode === ChallengeMode.CUSTOM_PARAMETERS_TEST && (
              <div className={classes.customParams}>
                <b className={classes.customParameter}>{t("player.results.customParameters")}</b>
                {session.parametricResults.map((pr) => (
                  <span className={classes.customParameter}>
                    {pr.parameterName}: {getParametricScore(pr, challenge.displayParametricResultMode)}
                  </span>
                ))}
              </div>
            )}

            <SessionActionsList
              challenge={challenge}
              actionsResults={session.actionResults}
              actions={actions}
              additionalScenarios={additionalScenarios}
              finishedScenarios={session.finishedScenariosIds}
            />
          </div>
        ),
      });
    },
    [challenge, session, actions, additionalScenarios, addModal, t],
  );

  return (
    <>
      {session.isContentMatches ? (
        <Link disabled={!session.isContentMatches} onClick={showDetailedResults}>
          {t("results.showDetailed")}
        </Link>
      ) : (
        <span className={classes.noDetails}>
          {!challenge?.showDetailedResults ? t("results.noDetailedResult") : t("results.challengeChanged")}
        </span>
      )}
    </>
  );
}
